import React from 'react';
import { View, ScrollView, Text, TextInput, Alert } from 'react-native';
import { connect } from 'react-redux';

import Colors from "../../../constants/Colors";
import {ButtonWithSpinner, InformationDialogue, Spacing, SpinnerDialogue} from "../../../components";
import {stringIsEmpty} from "../../../constants/StringChecker";
import post from "../../../api/methods/post";
import {CREATE_TOPIC} from "../api/forumEndpoints";
import NavBar from "../../../components/NavBar";

class TopicCreateScreen extends React.Component {

    state = {
        topicTitle: "",
        topicDescription: "",

        isSending: false,
        showSuccessModal: false,
        showErrorModal: false,
        errorMessage: ""
    }

    sendTopic = async () => {

        if (stringIsEmpty(this.state.topicTitle) || stringIsEmpty(this.state.topicDescription)) {
            this.setState({
                showErrorModal: true,
                errorMessage: 'É necessário preencher o campo de Título e Descrição para criar um tópico.'
            });
            return;
        }

        if (this.state.isSending) return;
        this.setState({ isSending: true });

        try {

            const payload = {
                userId: this.props.userId,
                journeyId: this.props.journeyId,
                title: this.state.topicTitle,
                description: this.state.topicDescription
            }

            let result = await post(CREATE_TOPIC, payload);

            this.setState({ showSuccessModal: true })

        } catch (e) {
            console.log(e);
            this.setState({
                showErrorModal: true,
                errorMessage: "Ocorreu um erro ao criar o seu tópico, tente novamente mais tarde.",
            });
        }

        this.setState({ isSending: false });
    }

    render() {
        return (
            <NavBar title={"Novo tópico"}>

                <SpinnerDialogue
                    isModalVisible={this.state.isSending}
                    onClose={() => {}}
                    isFinished={!this.state.isSending}
                    titleProps={"Criando Tópico"}
                    messageProps={"Estamos criando o seu tópico!"}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"Criamos o seu tópico com sucesso! Ele já está disponível na secção Fórum!"}
                    onClose={() => this.props.history.goBack()}
                />

                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={this.state.errorMessage}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <View style={{ padding: 18, width: 600 }}>

                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                        Título:
                    </Text>
                    <TextInput
                        style={{ backgroundColor: Colors.cardBackgroundColor, color: 'white', minHeight: 60, maxHeight: 60, padding: 8, borderRadius: 8}}
                        value={this.state.topicTitle}
                        placeholder={"Título do seu tópico"}
                        placeholderTextColor={'white'}
                        onChangeText={(newValue) => this.setState({ topicTitle: newValue })}
                        maxLenght={80}
                    />

                    <Spacing height={12} />

                    <Text style={{ fontSize: 22, color: Colors.fontColorOnBackground }}>
                        Descrição:
                    </Text>
                    <TextInput
                        style={{ backgroundColor: Colors.cardBackgroundColor, color: 'white', minHeight: 140, maxHeight: 140, padding: 8, borderRadius: 8, textAlignVertical: 'top'}}
                        value={this.state.topicDescription}
                        placeholder={"Descrição do seu tópico"}
                        placeholderTextColor={'white'}
                        onChangeText={(newValue) => this.setState({ topicDescription: newValue })}
                        multiline
                    />

                    <Spacing height={12} />

                    <ButtonWithSpinner
                        isLoading={this.state.isSending}
                        text={'Criar'}
                        onPress={this.sendTopic}
                        containerPropsStyle={{ height: 40, borderRadius: 8 }}
                        textPropsStyle={{ fontSize: 18, }}
                    />

                </View>

            </NavBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        userId: state.user.userId,
        journeyId: state.journey.currentJourney.id,
    }
}

export default connect(mapStateToProps)(TopicCreateScreen);
